import React, { useEffect } from 'react';
import Styled from './styled';
import { useLocation } from 'react-router-dom';
import { Items } from 'shared/consts/shopData';
import Button from 'componets/Button';

const ShopItem = () => {
  const location = useLocation();
  const currentRoute = location.pathname.replace(/\/$/, '');

  const filteredItems = Items.filter(item => item.route === currentRoute);

  useEffect(() => {
    if (filteredItems.length === 0) {
      window.location.href = '../shop';
    }
  }, [filteredItems])

  return (
    <Styled.Wrapper>
      {filteredItems.map((item, index) => (
        <Styled.ShopBox key={index}>
          <Styled.ImageContainer>
            <img src={item.img} alt={item.title} draggable="false" />
          </Styled.ImageContainer>
          <Styled.Content>
            <Styled.InfoBox>
              <Styled.Title>{item.title}</Styled.Title>
              <Styled.Description>{item.description}</Styled.Description>
              <Styled.Author><strong>Автор:</strong>&nbsp;{item.author}</Styled.Author>
              <Styled.Price>{item.price} ₽</Styled.Price>
            </Styled.InfoBox>
            <Styled.ButtonContainer>
              <Button text='Связаться с автором' onClick={() => window.location.href = `${item.contact}`} />
            </Styled.ButtonContainer>
          </Styled.Content>
        </Styled.ShopBox>
      ))}
    </Styled.Wrapper>
  );
};

export default ShopItem;
